import { useAuthInfo } from '@propelauth/react';
import { useAtomValue } from 'jotai';
import { adminUiHiddenAtom } from '~/atoms/atoms';
import { zOrgMetadata, zUnsafeUserMetadata } from '~/common/auth/metadata/metadata';

export const useAuthData = () => {
  const adminUiHidden = useAtomValue(adminUiHiddenAtom);
  const userInfo = useAuthInfo();
  const orgs = userInfo.orgHelper?.getOrgs();

  const metaData = (userInfo.user?.properties?.metadata || {}) as Record<string, string | undefined>;
  const activeOrgIdFromMeta = metaData?.activeOrgId;

  const rawActiveOrg =
    (activeOrgIdFromMeta ? orgs?.find((x) => x.orgId === activeOrgIdFromMeta) : undefined) || orgs?.at(0);
  const activeOrg =
    rawActiveOrg ? { ...rawActiveOrg, orgMetadata: zOrgMetadata.safeParse(rawActiveOrg.orgMetadata).data } : undefined;

  const { role } = metaData;
  const isAdmin =
    (userInfo.user?.email.endsWith('@stably.ai') ||
      userInfo.user?.email.endsWith('@stably.dev') ||
      role === 'superAdmin') &&
    !adminUiHidden;
  const isSuperAdmin = role === 'superAdmin';

  const fullName = [userInfo.user?.firstName, userInfo.user?.lastName].filter(Boolean).join(' ');
  const displayName = userInfo.user?.username || fullName || userInfo.user?.email || 'myself';

  const { data: unsafeMetadata } = zUnsafeUserMetadata.safeParse(userInfo.user?.properties?.unsafe_metadata || {});
  const orgMetadata = rawActiveOrg ? zOrgMetadata.safeParse(rawActiveOrg.orgMetadata).data : undefined;

  return { ...userInfo, activeOrg, isAdmin, isSuperAdmin, role, displayName, unsafeMetadata, orgMetadata };
};
